import React, { useState } from "react";
import "./calculator.css";

export default () => {
  const [l, setL] = useState(147.6);
  const [p, setP] = useState("");

  const calculateF = () => {
    const pVal = parseFloat(p);
    const lVal = parseFloat(l);
    if (isNaN(pVal) || isNaN(lVal) || pVal === 1) {
      return null;
    }
    return (-lVal * pVal) / (pVal - 1);
  };

  const fat = calculateF();
  const targetWeight = fat !== null ? parseFloat(l) + fat : null;

  return (
    <div className="calculator-container">
      <h1>Target Body Weight Calculator</h1>
      <p className="calculator-description">
        This calculator determines your target body weight based on your lean body mass and desired body fat percentage.
        It uses the formula <strong>f = -lp / (p - 1)</strong>, derived from the definition of body fat percentage:
        <strong> p = f / (f + l)</strong>, where <em>p</em> is body fat percentage (as a decimal), 
        <em>f</em> is fat mass, and <em>l</em> is lean body mass. Solving for <em>f</em> gives us the fat mass, 
        and adding it to lean mass gives your target weight.
      </p>
      <div className="calculator-form">
        <label>
          Lean Body Mass (l) - default: 147.6 lbs
          <input
            type="number"
            value={l}
            onChange={(e) => setL(e.target.value)}
            step="any"
          />
        </label>
        <label>
          Target Body Fat Percentage (p) - as decimal (e.g., 0.15 for 15%)
          <input
            type="number"
            value={p}
            onChange={(e) => setP(e.target.value)}
            placeholder="Enter body fat % as decimal"
            step="any"
          />
        </label>
        <div className="calculator-result">
          <h2>
            Target Weight: {targetWeight !== null ? targetWeight.toFixed(2) : "—"} lbs
          </h2>
          <p className="result-detail">
            (Lean: {l} lbs + Fat: {fat !== null ? fat.toFixed(2) : "—"} lbs)
          </p>
        </div>
      </div>
    </div>
  );
};
